import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "vorschlagMakler",
  novalidate: ""
}
const _hoisted_2 = ["placeholder", "aria-label", "data-fehlermeldung"]
const _hoisted_3 = ["required", "aria-required"]
const _hoisted_4 = ["required", "aria-required"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["required", "aria-required"]
const _hoisted_7 = ["required", "aria-required"]
const _hoisted_8 = ["required", "aria-required"]
const _hoisted_9 = ["min", "max"]
const _hoisted_10 = ["min", "max"]
const _hoisted_11 = ["min", "max"]
const _hoisted_12 = ["min", "max"]
const _hoisted_13 = {
  class: "c-form-control-radio__label",
  for: "nurProduktInformationen"
}
const _hoisted_14 = { class: "c-form-control-radio__label-text" }
const _hoisted_15 = {
  class: "c-form-control-checkbox__label control-label",
  for: "kopieAnMaklerCheck"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_Anrede = _resolveComponent("Anrede")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_Zeile = _resolveComponent("Zeile")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_Fehlermeldung = _resolveComponent("Fehlermeldung")!
  const _component_EmailBestaetigung = _resolveComponent("EmailBestaetigung")!
  const _component_buendel_dokument_links = _resolveComponent("buendel-dokument-links")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showError && !_ctx.showSuccess)
      ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "vertikal-zentrieren": false,
                "ausrichtung-responsiv": false
              }, {
                default: _withCtx(() => _cache[32] || (_cache[32] = [
                  _createTextVNode("Anrede")
                ])),
                _: 1,
                __: [32]
              }),
              _createVNode(_component_zelle, {
                breite: 12,
                class: "u-form-grid-nospace-y"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Anrede, {
                    id: "anrede",
                    required: true,
                    modelValue: _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede) = $event)),
                    ariaLabel: "Anrede",
                    tabindex: "0",
                    autofocus: true,
                    fehler: _ctx.fehler
                  }, null, 8, ["modelValue", "fehler"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.isOrganisation)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Name der " + _toDisplayString(_ctx.labelOrganisation), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, {
                    breite: 12,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "organisation",
                        name: "organisation",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.organisation) = $event)),
                        class: "c-form-control__input",
                        "data-cy": "organisation",
                        placeholder: _ctx.organisationPlatzhalter,
                        minlength: "2",
                        maxlength: "40",
                        required: "",
                        "aria-required": "true",
                        "aria-label": _ctx.labelOrganisation,
                        "data-fehlermeldung": _ctx.organisationFehlermeldung
                      }, null, 8, _hoisted_2), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.organisation,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.organisation
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vorname " + _toDisplayString(!_ctx.istFirma ? "" : " (optional)"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Name " + _toDisplayString(!_ctx.istFirma ? "" : " (optional)"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "vorname",
                        name: "vorname",
                        class: "c-form-control__input",
                        "data-cy": "vorname",
                        placeholder: "Vorname",
                        minlength: "2",
                        maxlength: "40",
                        required: !_ctx.istFirma,
                        "aria-required": !_ctx.istFirma,
                        "aria-label": "Vorname",
                        "data-fehlermeldung": "Bitte den Vornamen eingeben (2-40 Zeichen).",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.vorname) = $event))
                      }, null, 8, _hoisted_3), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.vorname,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.vorname
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "nachname",
                        name: "nachname",
                        class: "c-form-control__input",
                        "data-cy": "nachname",
                        placeholder: "Name",
                        minlength: "2",
                        maxlength: "40",
                        required: !_ctx.istFirma,
                        "aria-required": !_ctx.istFirma,
                        "aria-label": "Nachname",
                        "data-parsley-combined-name-length": "40",
                        "data-fehlermeldung": "Bitte den Nachnamen eingeben (2-40 Zeichen).",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.nachname) = $event))
                      }, null, 8, _hoisted_4), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.nachname,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.nachname
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode(" PLZ (optional) ")
                    ])),
                    _: 1,
                    __: [33]
                  }),
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createTextVNode(" Ort (optional) ")
                    ])),
                    _: 1,
                    __: [34]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "plz",
                        name: "plz",
                        class: "c-form-control__input",
                        "data-cy": "plz",
                        type: "text",
                        placeholder: "PLZ",
                        minlength: "5",
                        maxlength: "5",
                        min: "01001",
                        max: "99998",
                        "aria-label": "Postleitzahl",
                        "data-fehlermeldung": "Bitte eine gültige\n                Postleitzahl eingeben.",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz) = $event)),
                        disabled: _ctx.istVhvVerkaufsprodukt(_ctx.piniaStore.state)
                      }, null, 8, _hoisted_5), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.plz
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "ort",
                        name: "ort",
                        class: "c-form-control__input",
                        "data-cy": "ort",
                        type: "text",
                        placeholder: "Ort",
                        minlength: "2",
                        maxlength: "40",
                        "aria-label": "Ort",
                        "data-fehlermeldung": "Bitte den Ort eingeben (max. 40 Zeichen).",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.ort
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode(" Straße (optional) ")
                    ])),
                    _: 1,
                    __: [35]
                  }),
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createTextVNode(" Nummer (optional) ")
                    ])),
                    _: 1,
                    __: [36]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "strasse",
                        name: "strasse",
                        class: "c-form-control__input",
                        "data-cy": "strasse",
                        type: "text",
                        placeholder: "Straße",
                        minlength: "2",
                        maxlength: "60",
                        "aria-label": "Straße",
                        "data-fehlermeldung": "Bitte die Straße eingeben (max. 60 Zeichen).",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.strasse
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "nummer",
                        name: "nummer",
                        class: "c-form-control__input",
                        "data-cy": "hausnummer",
                        type: "text",
                        placeholder: "Nr.",
                        minlength: "1",
                        maxlength: "10",
                        "aria-label": "Hausnummer",
                        "data-fehlermeldung": "Bitte die Hausnummer eingeben (max. 10 Zeichen).",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.nummer
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 7 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                      _createTextVNode(" Anrede des Verwalters ")
                    ])),
                    _: 1,
                    __: [37]
                  }),
                  (!_ctx.istVerwalterFirma)
                    ? (_openBlock(), _createBlock(_component_titel_zelle, {
                        key: 0,
                        breite: 6,
                        "vertikal-zentrieren": false,
                        "ausrichtung-responsiv": false
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createTextVNode(" Titel des Verwalters ")
                        ])),
                        _: 1,
                        __: [38]
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Anrede, {
                        id: "verwalterAnrede",
                        fehler: _ctx.fehler,
                        "ist-verwalter": true,
                        modelValue: _ctx.piniaStore.state.personendaten.verwalter.anrede,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.anrede) = $event)),
                        required: true,
                        ariaLabel: "Anrede des Verwalters"
                      }, null, 8, ["fehler", "modelValue"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.istVerwalterFirma)
                    ? (_openBlock(), _createBlock(_component_zelle, {
                        key: 0,
                        breite: 6
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("select", {
                            id: "verwalterTitel",
                            name: "verwalterTitel",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.titel) = $event)),
                            class: "c-form-control-select",
                            "data-cy": "verwalterTitel",
                            "aria-label": "Titel des Verwalters"
                          }, _cache[39] || (_cache[39] = [
                            _createElementVNode("option", { value: "" }, "Titel", -1),
                            _createElementVNode("option", { value: "Dipl.Ing." }, "Dipl. Ing.", -1),
                            _createElementVNode("option", { value: "Dr." }, "Dr.", -1),
                            _createElementVNode("option", { value: "Prof.Dr." }, "Prof. Dr.", -1)
                          ]), 512), [
                            [_vModelSelect, _ctx.piniaStore.state.personendaten.verwalter.titel]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.verwalterTitel,
                            "reduzierter-abstand": true
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg && _ctx.istVerwalterFirma)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 9 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                      _createTextVNode(" Name der Firma ")
                    ])),
                    _: 1,
                    __: [40]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 12,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "verwalterOrganisation",
                        name: "verwalterOrganisation",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.organisation) = $event)),
                        class: "c-form-control__input",
                        "data-cy": "verwalter-organisation",
                        placeholder: "Firma",
                        minlength: "2",
                        maxlength: "40",
                        required: _ctx.istVerwalterFirma,
                        "aria-required": _ctx.istVerwalterFirma,
                        "aria-label": "Name der Verwalterfirma",
                        "data-fehlermeldung": "Bitte geben Sie den Namen der Firma ein (2-40 Zeichen)."
                      }, null, 8, _hoisted_6), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.verwalter.organisation,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.verwalterOrganisation
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vorname des Verwalters " + _toDisplayString(!_ctx.istVerwalterFirma ? "" : " (optional)"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Name des Verwalters " + _toDisplayString(!_ctx.istVerwalterFirma ? "" : " (optional)"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "vornameVerwalter",
                        name: "vornameVerwalter",
                        class: "c-form-control__input",
                        "data-cy": "vorname",
                        placeholder: "Vorname",
                        minlength: "2",
                        maxlength: "40",
                        required: !_ctx.istVerwalterFirma,
                        "aria-required": !_ctx.istVerwalterFirma,
                        "aria-label": "Vorname",
                        "data-fehlermeldung": "Bitte den Vornamen eingeben (2-40 Zeichen).",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.vorname) = $event))
                      }, null, 8, _hoisted_7), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.verwalter.vorname,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.vornameVerwalter
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "nachnameVerwalter",
                        name: "nachnameVerwalter",
                        class: "c-form-control__input",
                        "data-cy": "nachname",
                        placeholder: "Name",
                        minlength: "2",
                        maxlength: "40",
                        required: !_ctx.istVerwalterFirma,
                        "aria-required": !_ctx.istVerwalterFirma,
                        "aria-label": "Nachname",
                        "data-parsley-combined-name-length": "40",
                        "data-fehlermeldung": "Bitte den Nachnamen eingeben (2-40 Zeichen).",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.nachname) = $event))
                      }, null, 8, _hoisted_8), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.verwalter.nachname,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.nachnameVerwalter
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                      _createTextVNode(" PLZ (optional) ")
                    ])),
                    _: 1,
                    __: [41]
                  }),
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createTextVNode(" Ort (optional) ")
                    ])),
                    _: 1,
                    __: [42]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 13 }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "plzVerwalter",
                        name: "plzVerwalter",
                        class: "c-form-control__input",
                        "data-cy": "plz",
                        type: "text",
                        placeholder: "PLZ",
                        minlength: "5",
                        maxlength: "5",
                        min: "01001",
                        max: "99998",
                        "aria-label": "Postleitzahl",
                        "data-fehlermeldung": "Bitte eine gültige Postleitzahl eingeben.",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.plz) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.verwalter.adresse.plz,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.plzVerwalter
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "ortVerwalter",
                        name: "ortVerwalter",
                        class: "c-form-control__input",
                        "data-cy": "ort",
                        type: "text",
                        placeholder: "Ort",
                        minlength: "2",
                        maxlength: "40",
                        "aria-label": "Ort",
                        "data-fehlermeldung": "Bitte den Ort eingeben (max. 40 Zeichen).",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.ort) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.verwalter.adresse.ort,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.ortVerwalter
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 14 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                      _createTextVNode(" Straße (optional) ")
                    ])),
                    _: 1,
                    __: [43]
                  }),
                  _createVNode(_component_titel_zelle, {
                    breite: 6,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[44] || (_cache[44] = [
                      _createTextVNode(" Nummer (optional) ")
                    ])),
                    _: 1,
                    __: [44]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEtgWeg)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "strasseVerwalter",
                        name: "strasseVerwalter",
                        class: "c-form-control__input",
                        "data-cy": "strasse",
                        type: "text",
                        placeholder: "Straße",
                        minlength: "2",
                        maxlength: "60",
                        "aria-label": "Straße",
                        "data-fehlermeldung": "Bitte die Straße eingeben (max. 60 Zeichen).",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.strasse) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.verwalter.adresse.strasse,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.strasseVerwalter
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, {
                    breite: 6,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "nummerVerwalter",
                        name: "nummerVerwalter",
                        class: "c-form-control__input",
                        "data-cy": "hausnummer",
                        type: "text",
                        placeholder: "Nr.",
                        minlength: "1",
                        maxlength: "10",
                        "aria-label": "Hausnummer",
                        "data-fehlermeldung": "Bitte die Hausnummer eingeben (max. 10 Zeichen).",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.adresse.hausnummer) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.verwalter.adresse.hausnummer,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.nummerVerwalter
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state))
            ? (_openBlock(), _createBlock(_component_zeile, { key: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                      _createTextVNode("Versicherungsbeginn")
                    ])),
                    _: 1,
                    __: [45]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 12,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "versicherungsbeginn",
                        name: "versicherungsbeginn",
                        class: "c-form-control__input",
                        type: "date",
                        "data-cy": "tariffStartDate",
                        title: "Versicherungsbeginn im Format TT.MM.JJJJ",
                        min: _ctx.getIsoDateNow(),
                        max: _ctx.getIsoDatePlusYears(2),
                        minlength: "10",
                        maxlength: "10",
                        pattern: "[0-9]{2}.[0-9]{2}.[0-9]{4}",
                        required: "",
                        "aria-required": "true",
                        "aria-label": "Versicherungsbeginn im Format TT.MM.JJJJ",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.versicherungsbeginn) = $event))
                      }, null, 8, _hoisted_9), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.tarifinformationen.versicherungsbeginn,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.versicherungsbeginn
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state) && _ctx.enthaeltVGV(_ctx.piniaStore.state))
            ? (_openBlock(), _createBlock(_component_zeile, { key: 17 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 12,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                      _createTextVNode(" Versicherungsbeginn "),
                      _createElementVNode("strong", null, "Wohngebäude", -1)
                    ])),
                    _: 1,
                    __: [46]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 12,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "versicherungsbeginn",
                        name: "versicherungsbeginn",
                        class: "c-form-control__input",
                        type: "date",
                        "data-cy": "tariffStartDate",
                        title: "Versicherungsbeginn im Format TT.MM.JJJJ",
                        min: _ctx.getIsoDateNow(),
                        max: _ctx.getIsoDatePlusYears(2),
                        minlength: "10",
                        maxlength: "10",
                        pattern: "[0-9]{2}.[0-9]{2}.[0-9]{4}",
                        required: "",
                        "aria-required": "true",
                        "aria-label": "Versicherungsbeginn Wohngebäude im Format TT.MM.JJJJ",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vgv.tarifinformationen.versicherungsbeginn) = $event))
                      }, null, 8, _hoisted_10), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.ferienhaus.vgv.tarifinformationen.versicherungsbeginn,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.versicherungsbeginn
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state) && _ctx.enthaeltVHV(_ctx.piniaStore.state))
            ? (_openBlock(), _createBlock(_component_zeile, { key: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 12,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                      _createTextVNode("Versicherungsbeginn "),
                      _createElementVNode("strong", null, "Hausrat", -1)
                    ])),
                    _: 1,
                    __: [47]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 12,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "versicherungsbeginn",
                        name: "versicherungsbeginn",
                        class: "c-form-control__input",
                        type: "date",
                        "data-cy": "tariffStartDate",
                        title: "Versicherungsbeginn im Format TT.MM.JJJJ",
                        min: _ctx.getIsoDateNow(),
                        max: _ctx.getIsoDatePlusYears(2),
                        minlength: "10",
                        maxlength: "10",
                        pattern: "[0-9]{2}.[0-9]{2}.[0-9]{4}",
                        required: "",
                        "aria-required": "true",
                        "aria-label": "Versicherungsbeginn Hausrat im Format TT.MM.JJJJ",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.versicherungsbeginn) = $event))
                      }, null, 8, _hoisted_11), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.versicherungsbeginn,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.versicherungsbeginn
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
        _ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state) &&
        _ctx.enthaeltVGV(_ctx.piniaStore.state) &&
        _ctx.piniaStore.state.tarifinformationen.hausundgrundbesitzerhaftpflicht
      )
            ? (_openBlock(), _createBlock(_component_zeile, { key: 19 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 12,
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                      _createTextVNode("Versicherungsbeginn "),
                      _createElementVNode("strong", null, "Haus- und Grundbesitzerhaftpflicht", -1)
                    ])),
                    _: 1,
                    __: [48]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 12,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "versicherungsbeginn",
                        name: "versicherungsbeginn",
                        class: "c-form-control__input",
                        type: "date",
                        "data-cy": "tariffStartDate",
                        title: "Versicherungsbeginn im Format TT.MM.JJJJ",
                        min: _ctx.getIsoDateNow(),
                        max: _ctx.getIsoDatePlusYears(2),
                        minlength: "10",
                        maxlength: "10",
                        pattern: "[0-9]{2}.[0-9]{2}.[0-9]{4}",
                        required: "",
                        "aria-required": "true",
                        "aria-label": "Versicherungsbeginn Haus- und Grundbesitzerhaftpflicht im Format TT.MM.JJJJ",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.hug.tarifinformationen.versicherungsbeginn) = $event))
                      }, null, 8, _hoisted_12), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.ferienhaus.hug.tarifinformationen.versicherungsbeginn,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.versicherungsbeginn
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "vertikal-zentrieren": false,
                "ausrichtung-responsiv": false
              }, {
                default: _withCtx(() => _cache[49] || (_cache[49] = [
                  _createElementVNode("h3", { class: "u-color-primary" }, [
                    _createElementVNode("strong", null, "Beilagen")
                  ], -1)
                ])),
                _: 1,
                __: [49]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              (!_ctx.antrag)
                ? (_openBlock(), _createBlock(_component_zelle, {
                    key: 0,
                    breite: 4,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "nurVorschlag",
                        name: "nurVorschlag",
                        class: "c-form-control-radio__input",
                        "data-cy": "nurVorschlag",
                        type: "radio",
                        value: "NUR_VORSCHLAG",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.piniaStore.state.korrespondenz.beilagen) = $event)),
                        "aria-label": "Nur Vorschlag"
                      }, null, 512), [
                        [_vModelRadio, _ctx.piniaStore.state.korrespondenz.beilagen]
                      ]),
                      _cache[50] || (_cache[50] = _createElementVNode("label", {
                        for: "nurVorschlag",
                        class: "c-form-control-radio__label"
                      }, [
                        _createElementVNode("span", {
                          "aria-hidden": "true",
                          class: "c-form-control-radio__icon"
                        }),
                        _createElementVNode("span", { class: "c-form-control-radio__label-text" }, "Nur Vorschlag")
                      ], -1))
                    ]),
                    _: 1,
                    __: [50]
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_zelle, {
                breite: 4,
                class: "u-form-grid-nospace-y"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    id: "nurProduktInformationen",
                    name: "nurProduktinformationen",
                    class: "c-form-control-radio__input",
                    "data-cy": "nurProduktInformationen",
                    type: "radio",
                    value: "VORSCHLAG_UND_PRODUKTINFORMATIONEN",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.piniaStore.state.korrespondenz.beilagen) = $event)),
                    "aria-label": "Antrag / Vorschlag mit Produktinformationen"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.korrespondenz.beilagen]
                  ]),
                  _createElementVNode("label", _hoisted_13, [
                    _cache[51] || (_cache[51] = _createElementVNode("span", {
                      "aria-hidden": "true",
                      class: "c-form-control-radio__icon"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.antrag ? "Antrag" : "Vorschlag") + " mit Produktinfos", 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, {
                breite: 4,
                class: "u-form-grid-nospace-y"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    id: "vollstaendigeUnterlagen",
                    name: "vollstaendigeUnterlagen",
                    class: "c-form-control-radio__input",
                    "data-cy": "vollstaendigeUnterlagen",
                    type: "radio",
                    value: "VOLLSTAENDIG",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.piniaStore.state.korrespondenz.beilagen) = $event)),
                    "aria-label": "Vollständige Unterlagen"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.korrespondenz.beilagen]
                  ]),
                  _cache[52] || (_cache[52] = _createElementVNode("label", {
                    class: "c-form-control-radio__label",
                    for: "vollstaendigeUnterlagen"
                  }, [
                    _createElementVNode("span", {
                      "aria-hidden": "true",
                      class: "c-form-control-radio__icon"
                    }),
                    _createElementVNode("span", { class: "c-form-control-radio__label-text" }, "Vollständig")
                  ], -1))
                ]),
                _: 1,
                __: [52]
              })
            ]),
            _: 1
          }),
          (_ctx.isVorschlagEmail)
            ? (_openBlock(), _createBlock(_component_Zeile, { key: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                      _createElementVNode("h3", { class: "u-color-primary" }, [
                        _createElementVNode("strong", null, "Per E-Mail versenden an")
                      ], -1)
                    ])),
                    _: 1,
                    __: [53]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isVorschlagEmail)
            ? (_openBlock(), _createBlock(_component_zeile, { key: 21 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                      _createTextVNode("E-Mail-Adresse Kunde")
                    ])),
                    _: 1,
                    __: [54]
                  }),
                  (!_ctx.isEtgWeg)
                    ? (_openBlock(), _createBlock(_component_zelle, {
                        key: 0,
                        breite: 12,
                        class: "u-form-grid-nospace-y"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            id: "email",
                            name: "email",
                            class: "c-form-control__input",
                            "data-cy": "email",
                            placeholder: "E-Mail",
                            minlength: "2",
                            maxlength: "60",
                            required: "",
                            "aria-required": "true",
                            "aria-label": "Email",
                            "data-fehlermeldung": "Bitte die E-Mail-Adresse eingeben (2-60 Zeichen).",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.email) = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.versicherungsnehmer.email,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.email
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isEtgWeg)
                    ? (_openBlock(), _createBlock(_component_zelle, {
                        key: 1,
                        breite: 12,
                        class: "u-form-grid-nospace-y"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            id: "email",
                            name: "email",
                            class: "c-form-control__input",
                            "data-cy": "email",
                            placeholder: "E-Mail",
                            minlength: "2",
                            maxlength: "60",
                            required: "",
                            "aria-required": "true",
                            "aria-label": "Email",
                            "data-fehlermeldung": "Bitte die E-Mail-Adresse eingeben (2-60 Zeichen).",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalter.email) = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.verwalter.email,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.email
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isVorschlagEmail)
            ? (_openBlock(), _createBlock(_component_zeile, {
                key: 22,
                class: "c-form-control-checkbox form-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, { breite: 12 }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "kopieAnMaklerCheck",
                        name: "kopieAnMaklerCheck",
                        class: "c-form-control-checkbox__input c-form-control-checkbox__input--spring",
                        "data-cy": "kopieAnMaklerCheck",
                        type: "checkbox",
                        "data-fehlermeldung": "",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.piniaStore.state.korrespondenz.kopieAnMakler) = $event)),
                        "aria-label": "Kopie an Makler-E-Mail-Adresse"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.piniaStore.state.korrespondenz.kopieAnMakler]
                      ]),
                      _createElementVNode("label", _hoisted_15, [
                        _createVNode(_component_icon_sprite, {
                          "ist-klein": true,
                          "css-klassen": "c-form-control-checkbox__icon",
                          "icon-name": "icon-check-mark"
                        }),
                        _cache[55] || (_cache[55] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, "Kopie an Makler-E-Mail-Adresse.", -1))
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.kopieAnMaklerCheck
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_zeile, { style: {"padding-top":"32px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_zelle, { breite: 3 }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    id: "quoteByEmailCancelBtn",
                    class: "c-button c-button--inverted",
                    "data-cy": "cancelModalData",
                    type: "button",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.closeModal()))
                  }, " Schließen ")
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, { breite: 3 }, {
                default: _withCtx(() => [
                  (_ctx.speichernMoeglich)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        id: "quoteByEmailContinueBtn",
                        class: "c-button right",
                        "data-cy": "submitModalData",
                        type: "button",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.dokumentSpeichern()))
                      }, " Speichern "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, { breite: 3 }, {
                default: _withCtx(() => [
                  (_ctx.speichernMoeglich)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        id: "quoteByEmailContinueBtn",
                        class: "c-button right u-pad-0 u-pad-x-1",
                        "data-cy": "submitModalData",
                        type: "button",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.dokumentNeuSpeichern()))
                      }, " Variante speichern "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, { breite: 3 }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    id: "quoteByEmailContinueBtn",
                    class: "c-button right u-pad-0 u-pad-x-1",
                    "data-cy": "submitModalData",
                    type: "button",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submitModalData()))
                  }, _toDisplayString(_ctx.isVorschlagEmail === true ? "E-Mail versenden" : "Herunterladen"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showError)
      ? (_openBlock(), _createBlock(_component_Fehlermeldung, {
          key: 1,
          onCloseModal: _ctx.closeModal,
          onResetForm: _ctx.resetForm
        }, null, 8, ["onCloseModal", "onResetForm"]))
      : _createCommentVNode("", true),
    (_ctx.showSuccess)
      ? (_openBlock(), _createBlock(_component_EmailBestaetigung, {
          key: 2,
          onCloseModal: _ctx.closeModal
        }, null, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-ferienhausDownload'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 3,
          titel: _ctx.beschriftung + ' herunterladen',
          text: "Download-Links:",
          onCloseModal: _cache[31] || (_cache[31] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-ferienhausDownload')))
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_buendel_dokument_links, {
              antrag: _ctx.antrag,
              trackingZusatz: _ctx.trackingZusatz,
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["antrag", "trackingZusatz", "onTextVerbergen"])
          ]),
          _: 1
        }, 8, ["titel"]))
      : _createCommentVNode("", true)
  ], 64))
}